<template>
  <b-form @submit.prevent="saveDesign" @keydown.enter.prevent>
    <b-row class="design-body m-0">
      <b-col class="design-page-canvas">
        <b-row class="design-page-canvas-header">
          <div style="width: 100%; padding-right: 10px">
            <router-link to="/design/glife" class="design-home float-left"
              >&larr;</router-link
            >
            <div class="design-title float-left">
              <img
                height="20px"
                src="@/assets/images/mechanics/mobile.svg"
                alt="Phone Icon"
              />
              <input
                type="text"
                v-model="form.name"
                placeholder="Enter Design Name"
                autofocus
              />
              <small class="text-danger" v-if="!isValidField('name')">
                {{ getErrorMessage("name") }}
              </small>
            </div>
            <div class="float-right mt-2">
              <b-button
                variant="primary"
                :disabled="loading"
                @click="form.published = true"
                type="submit"
                class="float-right new-badge"
              >
                <template v-if="loading && form.published">
                  Publishing...
                </template>
                <template v-else> Publish </template>
              </b-button>
              <b-button
                variant="primary"
                :disabled="loading"
                @click="form.published = false"
                type="submit"
                class="float-right new-badge invert-new-badge"
              >
                <template v-if="loading && !form.publish"> Saving... </template>
                <template v-else> Save </template>
              </b-button>
            </div>
          </div>
        </b-row>
        <b-row class="design-page-canvas-main">
          <b-col class="canvas-background">
            <b-row class="mt-4 mr-4">
              <b-col class="text-right">
                <span class="mr-3">Guides </span>
                <switches
                  v-model="guides"
                  theme="custom"
                  color="primary"
                ></switches>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div id="mobile-canvas" class="mx-auto">
                  <div
                    class="background-display mx-auto"
                    :style="
                      !form.background_image
                        ? 'background-color :' + form.color
                        : 'background:url(' + bgPreview + ') no-repeat center;'
                    "
                  >
                    <b-row>
                      <b-col
                        ><div
                          class="image-upload image-upload mx-auto"
                          style="overflow: hidden"
                        >
                          <p
                            class="form-list"
                            v-show="guides"
                            style="
                              position: absolute;
                              margin-left: -5px;
                              margin-top: -5px;
                            "
                          >
                            A
                          </p>
                          <div v-if="logoPreview">
                            <b-img :src="logoPreview" fluid />
                          </div></div
                      ></b-col>
                    </b-row>
                    <b-row class="mt-5 mb-2">
                      <b-col
                        ><p class="form-list mx-auto" v-show="guides">
                          B
                        </p></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center">
                        <p
                          class="form-list"
                          v-show="guides"
                          style="
                            position: absolute;
                            margin-left: 7px;
                            margin-top: -3px;
                          "
                        >
                          C
                        </p>
                        <button
                          class="canvas-button"
                          :style="
                            'background-color: ' +
                            form.button_color +
                            '!important; color: ' +
                            form.font_color +
                            '!important'
                          "
                        >
                          TEXT
                        </button></b-col
                      >
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="design-page-form" cols="4">
        <b-row>
          <b-col cols="10">
            <div role="group" class="sl-helper b-form-group form-group">
              <div style="height: 25px">
                <i class="form-list float-left">A</i>
                <label class="col-form-label pt-0 float-left">LOGO</label>
                <i class="guide-tooltip float-left" id="logo-tooltip"></i>
                <b-popover
                  target="logo-tooltip"
                  triggers="hover"
                  content="This is your company brand's logo that will appear when the customer application is launched."
                >
                </b-popover>
              </div>

              <span
                v-if="logoPreview"
                class="preview-remove-logo"
                v-b-modal="'delete-modal-logo'"
                ><svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20"
                  height="20"
                  class="icon icon-remove"
                >
                  <path
                    d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z"
                    fill="#ff8828"
                  ></path></svg
              ></span>
              <b-modal id="delete-modal-logo" title="Delete Logo Image">
                <p class="modal-main-message">
                  Are you sure you want delete this Logo?
                </p>
                <div slot="modal-footer">
                  <b-btn
                    variant="ghost"
                    class="mr-1 btn-cancel"
                    @click="hideModal('delete-modal-logo')"
                  >
                    Cancel
                  </b-btn>
                  <b-btn
                    variant="primary"
                    class="ml-1"
                    @click="removeImage('logo')"
                  >
                    Yes, Delete
                  </b-btn>
                </div>
              </b-modal>
              <div
                class="image-upload"
                style="overflow: hidden"
                v-b-modal.uploadLogo
              >
                <div v-if="logoPreview"><b-img :src="logoPreview" fluid /></div>
                <span class="img-icon"
                  ><img src="../../../assets/images/camera.svg" alt="Camera"
                /></span>
              </div>
              <em class="image-size">max of 200 x 200</em>
              <div class="text-danger mt-2" v-if="!isValidField('logo')">
                {{ getErrorMessage("logo") }}
              </div>
              <b-modal id="uploadLogo" title="Upload Logo">
                <div id="image-logo-container" class="border mx-auto">
                  <croppa
                    v-model="myLogoCroppa"
                    @new-image-drawn="onNewLogoImage"
                    @zoom="onLogoZoom"
                    :width="200"
                    :height="200"
                    placeholder="Choose a Logo"
                    :show-remove-button="true"
                    :placeholder-font-size="14"
                    remove-button-color="#ff8828"
                  >
                  </croppa>
                </div>
                <div id="logo-image-range-container" class="mx-auto mt-2">
                  <input
                    type="range"
                    class="custom-range"
                    @input="onLogoSliderChange"
                    :min="sliderLogoMin"
                    :max="sliderLogoMax"
                    step=".001"
                    v-model="sliderLogoVal"
                  />
                </div>
                <div slot="modal-footer">
                  <b-button
                    variant="secondary"
                    @click="hideUploadLogo"
                    style="margin-right: 0.25rem"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="saveUploadLogo"
                    style="margin-left: 0.25rem"
                  >
                    Save
                  </b-button>
                </div>
              </b-modal>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div role="group" class="sl-helper b-form-group form-group">
              <div style="height: 15px">
                <i class="form-list float-left">B</i>
                <label class="col-form-label pt-0 float-left">SPLASH</label>
                <i class="guide-tooltip float-left" id="splash-tooltip"></i>
                <b-popover
                  target="splash-tooltip"
                  triggers="hover"
                  content="Sets the background that will appear when the customer application is launched."
                >
                </b-popover>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group
              id="background-color"
              label="Background Color"
              label-for="background-color"
              class="sl-helper"
            >
              <b-form-input
                type="color"
                v-model="form.color"
                id="background-color"
                class=""
                required
              ></b-form-input>
              <em class="image-size">#FFFFFF</em>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <img
              style="margin-top: 32px; margin-left: -18px"
              src="../../../assets/images/icons/colorpicker.svg"
              alt="Color Picker"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10">
            <b-form-group
              id="bg-image"
              label="Background Image"
              label-for="bg-image"
              class="sl-helper"
            >
              <span
                v-if="bgPreview"
                class="preview-remove-bg"
                v-b-modal="'delete-modal-bg'"
                ><svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20"
                  height="20"
                  class="icon icon-remove"
                >
                  <path
                    d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z"
                    fill="#ff8828"
                  ></path></svg
              ></span>
              <b-modal id="delete-modal-bg" title="Delete Background Image">
                <p class="modal-main-message">
                  Are you sure you want delete this background image?
                </p>
                <div slot="modal-footer">
                  <b-btn
                    variant="ghost"
                    class="mr-1 btn-cancel"
                    @click="hideModal('delete-modal-bg')"
                  >
                    Cancel
                  </b-btn>
                  <b-btn
                    variant="primary"
                    class="ml-1"
                    @click="removeImage('bg')"
                  >
                    Yes, Delete
                  </b-btn>
                </div>
              </b-modal>
              <div
                class="image-upload image-upload-bg"
                style="margin-left: 10px; overflow: hidden"
                v-b-modal.uploadBGImage
              >
                <div v-if="bgPreview && form.background_image">
                  <b-img :src="bgPreview" fluid />
                </div>
                <span class="img-icon">
                  <img src="../../../assets/images/camera.svg" alt="Camera" />
                </span>
              </div>
              <em class="image-size">max of 1136 x 640</em>
              <b-modal id="uploadBGImage" title="Upload Background Image">
                <div
                  id="image-phone-bg-container"
                  style="width: 200px; height: 300px"
                  class="border mx-auto"
                >
                  <croppa
                    v-model="myBGCroppa"
                    @new-image-drawn="onNewBGImage"
                    @zoom="onBGZoom"
                    :width="200"
                    :height="300"
                    placeholder="Choose an Image"
                    :show-remove-button="true"
                    :placeholder-font-size="14"
                    remove-button-color="#ff8828"
                  >
                  </croppa>
                </div>
                <div id="badge-phone-bg-range-container" class="mx-auto mt-2">
                  <input
                    type="range"
                    class="custom-range"
                    id="customRangebg"
                    @input="onBGSliderChange"
                    :min="sliderBGMin"
                    :max="sliderBGMax"
                    step=".001"
                    v-model="sliderBGVal"
                  />
                </div>
                <div slot="modal-footer">
                  <b-button
                    variant="secondary"
                    @click="hideUploadBG"
                    style="margin-right: 0.25rem"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="saveUploadBG"
                    style="margin-left: 0.25rem"
                  >
                    Save
                  </b-button>
                </div>
              </b-modal>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div role="group" class="sl-helper b-form-group form-group">
              <div style="height: 15px">
                <i class="form-list float-left">C</i>
                <label class="col-form-label pt-0 float-left">MAIN COLOR</label>
                <i class="guide-tooltip float-left" id="main-color-tooltip"></i>
                <b-popover
                  target="main-color-tooltip"
                  triggers="hover"
                  content="Sets the color theme of your customer application."
                >
                </b-popover>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group
              id="main-color"
              label="Button, Border & Header"
              label-for="main-color"
              class="sl-helper"
            >
              <b-form-input
                type="color"
                v-model="form.button_color"
                id="main-color"
                class=""
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <img
              style="margin-top: 32px; margin-left: -18px"
              src="../../../assets/images/icons/colorpicker.svg"
              alt="Color Picker"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8">
            <b-form-group label="Button Text">
              <b-form-radio-group
                id="fontColor"
                v-model="form.font_color"
                name="fontColor"
              >
                <b-form-radio value="#000000"
                  ><span
                    class="btn-text btn-text-2"
                    :style="'background-color: ' + form.button_color"
                    >Aa</span
                  ></b-form-radio
                >
                <b-form-radio value="#FFFFFF"
                  ><span
                    class="btn-text btn-text-1"
                    :style="'background-color: ' + form.button_color"
                    >Aa</span
                  ></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
            <b-form-group class="d-none" label="Dark Mode">
              <b-form-radio-group
                id="darkMode"
                v-model="form.dark_mode"
                name="darkMode"
              >
                <b-form-radio value="0">Off</b-form-radio>
                <b-form-radio value="1">On</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Switches from "vue-switches";
import { Photoshop } from "vue-color";
import { mapState } from "vuex";
import notification from "@/services/notification";
import { validateErrorsState } from "@/mixins/validate";
import _ from "lodash";

export default {
  mixins: [validateErrorsState],
  data() {
    return {
      msg: "Design Form",
      guides: true,
      myLogoCroppa: {},
      sliderLogoVal: 0,
      sliderLogoMin: 0,
      sliderLogoMax: 0,
      myBGCroppa: {},
      sliderBGVal: 0,
      sliderBGMin: 0,
      sliderBGMax: 0,
      uuid: this.$route.params.id || null,
      form: {
        name: "",
        logo: "",
        background_image: "",
        color: "#EBECF0",
        button_color: "#FF8828",
        font_color: "#FFFFFF",
        published: false,
        dark_mode: 0,
      },
    };
  },

  methods: {
    async saveDesign() {
      this.$store.commit("designs/setErrors", null);
      const errors = {};

      if (!this.form.name) errors.name = "Design name is required.";

      if (!this.form.logo) errors.logo = "Logo is required.";

      if (Object.keys(errors).length) {
        this.$store.commit("designs/setErrors", errors);
        notification.warning("Oops, cannot save GLife design.");

        return;
      }

      if (!this.uuid)
        await this.$store.dispatch("designs/createGLifeDesign", this.form);
      else {
        const payload = _.clone(this.form);

        if (this.form.logo && this.isUrl(this.form.logo)) {
          this.form.logo = "";
          delete payload.logo;
        }

        if (
          this.form.background_image &&
          this.isUrl(this.form.background_image)
        ) {
          this.form.background_image = "";
          delete payload.background_image;
        }

        await this.$store.dispatch("designs/updateGLifeDesign", payload);
      }

      if (!this.errors) this.$router.push({ name: "gLifeDesign" });
    },
    onLogoZoom() {
      this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
    },
    onNewLogoImage() {
      this.sliderLogoVal = this.myLogoCroppa.scaleRatio;
      this.sliderLogoMin = this.myLogoCroppa.scaleRatio / 2;
      this.sliderLogoMax = this.myLogoCroppa.scaleRatio * 2;
    },
    onLogoSliderChange(evt) {
      let increment = evt.target.value;
      this.myLogoCroppa.scaleRatio = +increment;
    },
    hideUploadLogo() {
      this.$root.$emit("bv::hide::modal", "uploadLogo");
    },
    saveUploadLogo() {
      const base64Image = this.myLogoCroppa.generateDataUrl() || null;

      if (base64Image) {
        this.form.logo = base64Image.split("base64,").pop();
        this.hideUploadLogo();
      }
    },
    onBGZoom() {
      this.sliderBGVal = this.myBGCroppa.scaleRatio;
    },
    onNewBGImage() {
      this.sliderBGVal = this.myBGCroppa.scaleRatio;
      this.sliderBGMin = this.myBGCroppa.scaleRatio / 2;
      this.sliderBGMax = this.myBGCroppa.scaleRatio * 2;
    },
    onBGSliderChange(evt) {
      let increment = evt.target.value;
      this.myBGCroppa.scaleRatio = +increment;
    },
    hideUploadBG() {
      this.$root.$emit("bv::hide::modal", "uploadBGImage");
    },
    saveUploadBG() {
      const base64Image = this.myBGCroppa.generateDataUrl() || null;

      if (base64Image) {
        this.form.background_image = base64Image.split("base64,").pop();
        this.hideUploadBG();
      }
    },
    removeImage(type) {
      if (type == "bg") {
        this.form.background_image = "";
        this.myBGCroppa.remove();
        this.hideModal("delete-modal-bg");
      } else {
        this.form.logo = "";
        this.myLogoCroppa.remove();
        this.hideModal("delete-modal-logo");
      }
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    isUrl(value) {
      return /^(https:|http:|www\.)\S*/.test(value);
    },
  },
  components: {
    Switches,
    "photoshop-picker": Photoshop,
  },
  async created() {
    if (this.uuid) {
      await this.$store.dispatch("designs/getGLifeDesignDetails", this.uuid);

      if (this.gLifeDesignDetails) {
        this.form = _.omit(this.gLifeDesignDetails, [
          "merchant_uuid",
          "updated_at",
        ]);
      } else this.$router.push({ name: "gLifeDesign" });
    }

    this.$store.commit("designs/setErrors", null);
  },
  computed: {
    ...mapState("designs", ["loading", "errors", "gLifeDesignDetails"]),
    logoPreview() {
      if (this.form.logo) {
        return this.isUrl(this.form.logo)
          ? this.form.logo
          : `data:image/png;base64,${this.form.logo}`;
      }

      return null;
    },
    bgPreview() {
      if (this.form.background_image) {
        return this.isUrl(this.form.background_image)
          ? this.form.background_image
          : `data:image/png;base64,${this.form.background_image}`;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.design-page-canvas-header {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.design-home {
  padding: 3px 10px;
  border-right: 1px solid #ddd;
  font-size: 2em;
  color: #000;
}

.design-title {
  padding: 1em;
  input {
    border: none;
  }
}

.design-title img {
  margin-right: 10px;
}

// Colors
$bg-color: #f3f3f4;
$dot-color: #ccc;

// Dimensions
$dot-size: 2px;
$dot-space: 41px;

.canvas-background {
  min-height: 900px;
  background: linear-gradient(
        90deg,
        $bg-color ($dot-space - $dot-size),
        transparent 1%
      )
      center,
    linear-gradient($bg-color ($dot-space - $dot-size), transparent 1%) center,
    $dot-color;
  background-size: $dot-space $dot-space;
}

.design-page-form {
  padding-top: 20px;
  background-color: #fff;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  min-height: 900px;
}

.new-badge {
  font-size: 13px;
  border-radius: 22px;
  padding: 8px 16px;
  margin-left: 10px;
}

.new-badge.invert-new-badge {
  background-color: #fff;
  color: #ff8828;
}

.image-upload {
  width: 180px;
  height: 180px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  background: #ffffff
    url("../../../assets/images/achievement/default-image.svg") no-repeat center;
  img.image {
    width: 128px;
    height: 66px;
    border-radius: 5px;
  }

  span.img-icon {
    box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
    padding: 2px;
    border-radius: 12.5px;
    position: absolute;
    width: 25px;
    height: 25px;
    text-align: center;
    bottom: 40px;
    left: 165px;
  }
}
span.preview-remove-logo {
  top: 10px;
  left: 185px;
  position: absolute;
}

span.preview-remove-bg {
  top: 10px;
  left: 123px;
  position: absolute;
}

#mobile-canvas {
  background-image: url("../../../assets/images/mobile.png");
  background-repeat: no-repeat;
  background-position: center;
  min-height: 680px;
  width: 304px;
  padding-top: 62px;

  .background-display {
    padding-top: 70px;
    width: 248px;
    border-radius: 20px;
    padding-bottom: 163px;
  }

  h5 {
    font-family: MainFontBold, sans-serif;
  }

  .reward-description {
    font-family: MainFontRegular, sans-serif;
    font-size: 12px;
    color: #2a2a2a;
  }
  .reward-points {
    font-family: MainFontBold, sans-serif;
    font-size: 12px;
    color: #2a2a2a;
  }

  .image-upload {
    border: 1px dashed #e3e3e3;
  }

  button.canvas-button {
    width: 230px;
    font-size: 13px;
    border-radius: 22px;
    padding: 8px 16px;
    border: 1px solid #fff;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
  }
}

.image-upload-bg {
  height: 180px;
  width: 118px;
  span.img-icon {
    left: 112px;
    bottom: 40px;
  }
}

.form-list {
  width: 15px;
  height: 15px;
  padding: 2px;
  border-radius: 50%;
  background-color: #7a7a7a;
  color: #f7f8fb;
  font-size: 9px;
  text-align: center;
  cursor: pointer;
  margin-right: 5px;
}

.image-size {
  font-size: 10px;
  color: #b8b8b8;
}

.btn-text {
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  padding: 5px;
  border: 1px solid #b8b8b8;
  background-color: #15b0db;
  border-radius: 6px;
}

.btn-text-1 {
  color: #fff;
}

.btn-text-2 {
  color: #000;
}
</style>
